"use client";
import { Button } from "@/components/ui/button";
import { useSearchContext } from "@/lib/hooks/searchContext/searchStore";
import { usePathname, useRouter } from "next/navigation";
import { useVenueListPage } from "@/hooks/listPageContext";
import { useSite } from "@/lib/hooks/site";
import { useHeader } from "@/hooks/headerContext";

interface Props {
  title: string;
  searchText: string;
  showAllText: string;
  clearFilter?: () => void;
}

export default function NotFound(props: Props) {
  const { title, searchText, showAllText } = props;
  const { setIsOpen, setCurrentTab } = useSearchContext();
  const { clearFilters } = useHeader();
  const router = useRouter();
  const pathname = usePathname();
  const site = useSite();
  const { isVenueListPage } = useVenueListPage();

  const redirect = () => {
    router.push(
      !isVenueListPage ? pathname : `/${site.setting?.routes?.generalList}`,
    );

    if (props.clearFilter) {
      props.clearFilter();
      clearFilters();
    }
  };

  const search = () => {
    setCurrentTab(0);
    setIsOpen(true);
  };

  return (
    <div className="flex justify-center items-center flex-col gap-4">
      <span className="font-bold text-black text-3xl">{title}</span>

      <div className="flex flex-col gap-4">
        <Button className="min-w-60 !w-auto" variant="secondary" onClick={() => search()}>
          {searchText}
        </Button>

        <Button className="min-w-60 !w-auto" variant="primary" onClick={() => redirect()}>
          {showAllText}
        </Button>
      </div>
    </div>
  );
}
